import { render, staticRenderFns } from "./OrientationTabs.vue?vue&type=template&id=39033ff9&scoped=true"
import script from "./OrientationTabs.vue?vue&type=script&lang=js"
export * from "./OrientationTabs.vue?vue&type=script&lang=js"
import style0 from "./OrientationTabs.vue?vue&type=style&index=0&id=39033ff9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39033ff9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39033ff9')) {
      api.createRecord('39033ff9', component.options)
    } else {
      api.reload('39033ff9', component.options)
    }
    module.hot.accept("./OrientationTabs.vue?vue&type=template&id=39033ff9&scoped=true", function () {
      api.rerender('39033ff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/OrientationTabs/OrientationTabs.vue"
export default component.exports